import {clsx} from 'clsx'
import {twMerge} from 'tailwind-merge'

/**
 * The shadcn/Magic UI `cn` helper: clsx for conditionals, tailwind-merge
 * so a caller's `px-3` actually beats a component's default `px-6`
 * instead of leaving both classes to fight it out in stylesheet order.
 */
export const cn = (...inputs) => twMerge(clsx(inputs))

export default cn
